module.exports = __webpack_public_path__ + "img/aws.c748e971.svg";